import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";

function AbonosProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  // C7: opción de dar de alta anticipo desde esta misma pantalla
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
  const [valueProveedor, setValueProveedor] = useState(null);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [concepto, setConcepto] = useState("");
  const [tipoCambio, setTipoCambio] = useState(1);

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");
  // W10: comprobante de pago
  const [comprobanteFile, setComprobanteFile] = useState(null);
  const [urlComprobante, setUrlComprobante] = useState("");
  const [tipoComprobante, setTipoComprobante] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);

  const [inputFields, setInputFields] = useState([]);
  const [codigoAgrupado] = useState(uuidv4());

  // C7: en el mismo paso se pueden capturar abonos a notas + un anticipo.
  // El anticipo va en un renglón aparte debajo de la tabla.
  const [importeAnticipo, setImporteAnticipo] = useState(0);
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOC, setSelectedOC] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setProveedores(response.data || []);
      })
      .catch((err) => console.log(err));

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setBancos(response.data || []);
      })
      .catch((err) => console.log(err));
  }, []);

  // C7: cargar OCs activas del proveedor para el renglón de anticipo
  useEffect(() => {
    if (!selectedProveedor) {
      setOrdenesCompra([]);
      setSelectedOC("");
      setImporteAnticipo(0);
      return;
    }
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const ocs = (res.data || []).filter(
          (o) =>
            o.proveedores?.[0]?._id === selectedProveedor &&
            o.is_active === "Si"
        );
        setOrdenesCompra(ocs);
      })
      .catch((err) => console.log(err));
  }, [selectedProveedor]);

  useEffect(() => {
    if (!selectedProveedor) {
      setInputFields([]);
      setTotal(0);
      return;
    }
    axios
      .get(`${URL_NOTAS_CXP}Proveedor/${selectedProveedor}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const pendientes = (response.data || [])
          .filter((n) => Number(n.saldo) > 0 && n.is_active === "Si")
          .map((a) => ({
            id: a._id,
            fecha: a.fecha,
            embarque:
              a.embarques && a.embarques.length > 0
                ? `Emb #${a.embarques[0].idEmbarques}`
                : `Nota #${a.idNotasCxP}`,
            contenedor: a.embarques?.[0]?.contenedor || "",
            numero: a.idNotasCxP,
            total_costo: Number(a.total_costo || 0),
            saldo: Number((a.saldo || 0).toFixed(2)),
            importe: 0,
            completa: false,
            observaciones: "NA",
          }))
          .sort((a, b) => (a.fecha > b.fecha ? 1 : -1));
        setInputFields(pendientes);
        setTotal(0);
      })
      .catch((err) => console.log(err));
  }, [selectedProveedor]);

  const handleChangeInputImporte = (value, name, id) => {
    const next = inputFields.map((i) => {
      if (id !== i.id) return i;
      const importeNum = parseFloat(value) || 0;
      if (importeNum > i.saldo) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El Pago excede el Saldo",
        });
        return i;
      }
      return { ...i, importe: value, completa: false };
    });
    setInputFields(next);
    ActualizaTotales(next);
  };

  // Palomita: pasa todo el saldo de la nota a la columna de importe
  const toggleNotaCompleta = (id, checked) => {
    const next = inputFields.map((i) =>
      i.id === id
        ? checked
          ? { ...i, importe: i.saldo, completa: true }
          : { ...i, importe: 0, completa: false }
        : i
    );
    setInputFields(next);
    ActualizaTotales(next);
  };

  const handleChangeInputObs = (id, event) => {
    const next = inputFields.map((i) =>
      i.id === id ? { ...i, observaciones: event.target.value } : i
    );
    setInputFields(next);
  };

  function ActualizaTotales(rows = inputFields) {
    const TE = rows.reduce((acc, r) => acc + (parseFloat(r.importe) || 0), 0);
    setTotal(TE);
  }

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) setMoneda(a.moneda);
    });
  }

  const savePago = () => {
    const totalAbonos = Number(total) || 0;
    const totalAnticipo = Number(importeAnticipo) || 0;
    if (
      !selectedProveedor ||
      selectedBanco === "" ||
      (totalAbonos <= 0 && totalAnticipo <= 0)
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes seleccionar proveedor y banco, y capturar al menos un abono o un anticipo",
      });
      return;
    }
    if (totalAbonos > 0 && concepto === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes seleccionar concepto para los abonos a notas",
      });
      return;
    }

    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el pago",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setValidaBoton(false);
      toggleProgreso();

      // C7: si se capturó importe de anticipo, crearlo primero (patrón AnticiposProveedoresCreate)
      if (totalAnticipo > 0) {
        try {
          const antRes = await axios.post(
            URL_ANTICIPOS,
            {
              fecha,
              importe: totalAnticipo,
              formaPago: concepto || "Anticipo",
              bancos: selectedBanco,
              proveedores: selectedProveedor,
              ordenesCompra: selectedOC || null,
              utilizado: 0,
              saldo: totalAnticipo,
              tipoCambio: Number(tipoCambio) || 1,
              tipo: "Proveedor",
              observaciones: "NA",
            },
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          );
          await axios.post(
            URL_MOVIMIENTOS_BANCOS,
            {
              fecha,
              importe: -totalAnticipo,
              tipo: "Egreso",
              bancos: selectedBanco,
              anticipos: antRes.data._id,
              moneda,
              tipoCambio: 1,
            },
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          );
          axios.post(
            URL_LOGS,
            {
              tipo: "Crear Anticipo Proveedor",
              detalle: `Fecha: ${fecha} / Proveedor: ${selectedProveedor} / Importe: ${totalAnticipo}`,
              user: user.id,
            },
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          );
        } catch (err) {
          console.log(err);
          Swal.fire({ icon: "error", title: "Oops...", text: "Falló el anticipo" });
          setValidaBoton(true);
          setModalProgreso(false);
          return;
        }
      }

      const filas = inputFields.filter((a) => Number(a.importe) > 0);
      let pendientes = filas.length;
      if (pendientes === 0) {
        // Solo se pidió anticipo: cerrar aquí con éxito
        if (totalAnticipo > 0) {
          Swal.fire("Good job!", "Anticipo creado con exito", "success");
          setTimeout(() => window.location.reload(), 1000);
          return;
        }
        setModalProgreso(false);
        setValidaBoton(true);
        return;
      }

      filas.forEach((a) => {
        axios
          .post(
            URL_ABONOS_PROVEEDORES,
            {
              fecha,
              importe: parseFloat(a.importe),
              proveedores: selectedProveedor,
              concepto,
              tipoCambio,
              bancos: selectedBanco,
              notasCxP: a.id,
              observaciones: a.observaciones,
              ...(urlComprobante ? { urlComprobante, tipoComprobante } : {}),
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            axios
              .post(
                `${URL_MOVIMIENTOS_BANCOS}`,
                {
                  fecha,
                  importe: -parseFloat(a.importe),
                  tipo: "Egreso",
                  bancos: selectedBanco,
                  abonosProveedores: data.data._id,
                  moneda,
                  tipoCambio: 1,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .catch((err) => console.log(err));

            pendientes -= 1;
            if (pendientes === 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear Pago Proveedor",
                  detalle: `Fecha: ${fecha} / Proveedor: ${selectedProveedor} / Total: ${total}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
            console.log(error);
            setValidaBoton(true);
            setModalProgreso(false);
          });
      });
    });
  };

  const options = proveedores.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0]?.toUpperCase() || "0";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago a Proveedor</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => setFecha(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Autocomplete
                    size="small"
                    value={valueProveedor}
                    onChange={(event, sel) => {
                      if (sel) {
                        setValueProveedor(sel);
                        setSelectedProveedor(sel._id);
                      } else {
                        setValueProveedor(null);
                        setSelectedProveedor("");
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => setConcepto(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                    <option value="Descuento">Descuento</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => jalaBanco(e.target.value)}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => (
                        <option value={a._id}>
                          {a.banco} {a.cuenta}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">TC</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={tipoCambio}
                    onChange={(e) => setTipoCambio(e.target.value)}
                  />
                </Col>
                {/* <Col md={3}>
                  <Label className="mr-sm-2">Comprobante (PDF/imagen)</Label>
                  <Input
                    type="file"
                    accept="application/pdf,image/*"
                    onChange={async (e) => {
                      const f = e.target.files[0];
                      if (!f) return;
                      setComprobanteFile(f);
                      const fd = new FormData();
                      fd.append("file", f);
                      try {
                        const up = await axios.post(process.env.REACT_APP_URL_UPMEDIA, fd, {
                          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
                        });
                        setUrlComprobante(up.data?.secure_url || up.data?.url || "");
                        setTipoComprobante(f.type?.includes("pdf") ? "PDF" : "IMG");
                      } catch (err) {
                        console.log(err);
                      }
                    }}
                  />
                  {urlComprobante && (
                    <small style={{ color: "green" }}>
                      <i className="fas fa-check-circle"></i> Comprobante listo
                    </small>
                  )}
                </Col> */}
                <Col md={2}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(total)}
                    </Badge>
                  </h4>
                </Col>
              </Row>
              <br />
              <Row>
                <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Nota / Embarque</th>
                      <th>Contenedor</th>
                      <th>Total</th>
                      <th>Abonado</th>
                      <th>Saldo</th>
                      <th align="center">✓</th>
                      <th>Importe</th>
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((a) => (
                      <tr key={a.id}>
                        <td>{fDMA(a.fecha)}</td>
                        <td>{a.embarque}</td>
                        <td>{a.contenedor}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_costo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_costo - a.saldo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.saldo)}
                        </td>
                        <td align="center" style={{ verticalAlign: "middle" }}>
                          <Input
                            type="checkbox"
                            checked={a.completa || false}
                            onChange={(e) => toggleNotaCompleta(a.id, e.target.checked)}
                            style={{ position: "static", marginLeft: 0 }}
                          />
                        </td>
                        <td>
                          <CurrencyInput
                            intlConfig={{
                              locale: "en-US",
                              currency: "USD",
                            }}
                            prefix="$"
                            name="importe"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.importe}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputImporte(value, name, a.id)
                            }
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            onChange={(e) => handleChangeInputObs(a.id, e)}
                          />
                        </td>
                      </tr>
                    ))}
                    {inputFields.length === 0 && (
                      <tr>
                        <td colSpan="9" align="center">
                          {selectedProveedor
                            ? "Sin notas pendientes para este proveedor"
                            : "Selecciona un proveedor para ver sus notas pendientes"}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        Total
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(total)}
                      </td>
                      <td></td>
                    </tr>
                    {/* C7: renglón extra para dar de alta un anticipo en el mismo paso */}
                    <tr style={{ backgroundColor: "#fff3cd" }}>
                      <td colSpan="2" className="negrita">
                        Anticipo (opcional)
                      </td>
                      <td colSpan="3">
                        <Input
                          type="select"
                          // bsSize="sm"
                          value={selectedOC}
                          onChange={(e) => setSelectedOC(e.target.value)}
                          disabled={!selectedProveedor}
                          style={{ backgroundColor: "#ffffff", color: "#212529" }}
                        >
                          <option value="">Sin OC</option>
                          {ordenesCompra
                            .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1))
                            .map((a) => (
                              <option key={a._id} value={a._id}>
                                OC #{a.idOrdenCompra} / {a.fecha} / ${Number(a.total_general).toFixed(2)}
                              </option>
                            ))}
                        </Input>
                      </td>
                      <td className="negrita" align="right" colSpan="2">
                        Importe:
                      </td>
                      <td>
                        <CurrencyInput
                          intlConfig={{ locale: "en-US", currency: "USD" }}
                          prefix="$"
                          defaultValue={0}
                          decimalsLimit={2}
                          value={importeAnticipo}
                          className={`form-control`}
                          onValueChange={(value) => setImporteAnticipo(value || 0)}
                          disabled={!selectedProveedor}
                        />
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
              </Row>
            </FormGroup>
            <br />
            <Row>
              {validaBoton ? (
                <Button className="btn btn-success" onClick={savePago}>
                  Registrar
                </Button>
              ) : (
                <Button className="btn btn-success" disabled>
                  Registrar
                </Button>
              )}
              <Button
                href="/ListadoAbonosProveedores"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosProveedoresCreate;
